module.exports = __webpack_public_path__ + "static/img/10.4b2f206.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/eng/10.png
// module id = YWPB
// module chunks = 0